import WorkspacePartial from "../../partials/workspace/workspace.partial";

export default function WorkspaceScreen() {
  return <WorkspacePartial />;
}
